import properties from '../../modules/ajio-util/properties';

function addScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

/**
 * Ensures node-forge is on `window.forge`: tries unpkg CDN first, then local
 * `forgescript.js` (EJS-injected URL from DOM, or `/static/img/forgescript.js`).
 */
export function loadForge() {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }
  if (window.forge) {
    return Promise.resolve();
  }
  const staticUrl =  `${properties.getProperty('assetUrl')}/static/img/forgescript.js`;
  return addScript('https://unpkg.com/node-forge@0.7.0/dist/forge.min.js').catch(() =>
    addScript(staticUrl)
  );
  // return addScript(staticUrl);
}
